import React, { useEffect } from 'react'
import s from './SignUp.module.scss'
import { Formik, Field, Form } from 'formik';
import invis from '../../assets/SignUp/invisible.png'
import vis from '../../assets/SignUp/visible.png'
import { useState } from 'react';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { createUser, resetAuthError } from '../../store/authSlice';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';


export const SignUp = () => {
    const [passVis, setPassVis] = useState(false)
    const passType = passVis ? 'text' : 'password'
    const passIcon = passVis ? vis : invis
    const { statusCreate, error, isAuth } = useSelector(state => state.auth)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { t } = useTranslation()    

    const initialValues = {
        email: '',
        password: '',
    }
    const validationSchema = Yup.object().shape({
        email: Yup.string().matches(/^([a-z0-9_-]+\.)*[a-z0-9_-]+@[a-z0-9_-]+(\.[a-z0-9_-]+)*\.[a-z]{2,6}$/, t('invalidEmail'))
            .required(t('fieldIsRequired')),
        password: Yup.string().required(t('fieldIsRequired'))
            .min(8, t('minSymbols')).max(16, t('maxSymbols')),
    });
    const handleSubmit = (values) => {
        dispatch(createUser(values))
    }
    useEffect(() => {
        dispatch(resetAuthError())
    }, [dispatch])

    useEffect(() => {
        if (isAuth) {
            navigate('/userrecognition')
        }
    }, [isAuth, navigate])
    return (
        <div className={s.wrapper}>
            <div>
                <div className={s.container}>

                    <div className={`${s.content} ${statusCreate === 'loading' ? s.animate : ''}`}>
                        <div className={s.birds}></div>
                        <div className={s.formSignUp}>
                            <div className={s.formTittle}>
                                {t('signUp')}
                            </div>
                            <div>
                                <Formik

                                    initialValues={initialValues}
                                    validationSchema={validationSchema}
                                    onSubmit={(values) => {
                                        handleSubmit(values)
                                    }}>
                                    {({ touched, errors, values, setFieldValue }) => (
                                        <Form className={s.form}>
                                            <label htmlFor="email">
                                                {t('signEmail')}
                                            </label>
                                            <div className={s.inputField}>
                                                <Field
                                                    id="email"
                                                    name="email"
                                                    type="text" />
                                            </div>
                                            {errors.email && touched.email ?
                                                <>
                                                    <div className={s.redLine}></div>
                                                    <div className={s.error}>{errors.email}</div>
                                                </>
                                                : null}
                                            <label htmlFor="password">
                                                {t('signPassword')}
                                            </label>
                                            <div className={s.inputField}>
                                                <Field
                                                    name="password"
                                                    type={passType}
                                                /> <i onClick={() => setPassVis(!passVis)}>
                                                    <img className={s.vis} src={passIcon} alt="" /></i>
                                            </div>
                                            {errors.password && touched.password ?
                                                <>
                                                    <div className={s.redLine}></div>
                                                    <div className={s.error}>{errors.password}</div>
                                                </>
                                                : null}
                                            {error ? <div style={{ color: 'red' }}>{error}</div> : null}
                                            <button disabled={statusCreate === 'loading' ? true : false} className={s.signBtn} type="submit">
                                                {t('signUp')}
                                            </button>
                                        </Form>
                                    )}
                                </Formik>
                            </div>


                        </div>
                    </div>
                </div>
                <div className={s.upperCloud}></div>
                <div className={s.uuderCloud}></div>
            </div>

        </div>

    )
}